import { GameEvent, DayPhase } from '@/types/GameState';

export class EventSystem {
  private events: GameEvent[] = [
    {
      id: 'shark_attack',
      title: 'SHARK ATTACK!',
      description: 'A shark has been spotted near the lineup! One of the lads is freaking out.',
      allowedPhases: [DayPhase.BEACH], // Only at beach
      choices: [
        {
          text: 'Keep surfing - it\'s probably just a dolphin',
          effects: { groupMorale: -10, surfsSoFar: 1, energy: -15 }
        },
        {
          text: 'Get everyone out immediately',
          effects: { groupMorale: -5, energy: -5 }
        },
        {
          text: 'Send them to the bar to calm nerves',
          effects: { money: -60, hangoverLevel: 20, groupMorale: 10, partyCount: 1 }
        }
      ]
    },
    {
      id: 'lagos_trip',
      title: 'Road Trip to Lagos!',
      description: 'The entire group wants to hit Lagos for a massive night out. You can\'t say no.',
      allowedPhases: [DayPhase.MORNING], // Only at villa in the morning
      choices: [
        {
          text: 'Go all in - it\'s part of the experience',
          effects: { money: -120, hangoverLevel: 40, groupMorale: 30, energy: -50, partyCount: 1 }
        },
        {
          text: 'Try to pace yourself',
          effects: { money: -80, hangoverLevel: 25, groupMorale: 15, energy: -30, partyCount: 1 }
        }
      ]
    },
    {
      id: 'flat_surf',
      title: 'Flat as a Pancake',
      description: 'You check the forecast and conditions - it\'s completely flat everywhere! The boys are getting restless and eyeing the beer fridge.',
      allowedPhases: [DayPhase.MORNING], // Only at villa in morning
      choices: [
        {
          text: 'Let them drink - there\'s nothing else to do',
          effects: { hangoverLevel: 15, groupMorale: 10, energy: -10, partyCount: 1, timeOfDay: 3 }
        },
        {
          text: 'Organize alternative activities',
          effects: { money: -30, groupMorale: 5, energy: -5, timeOfDay: 4 }
        },
        {
          text: 'Drive around looking for any rideable waves',
          effects: { money: -40, energy: -20, surfsSoFar: 1, groupMorale: 15, timeOfDay: 5 }
        }
      ]
    },
    {
      id: 'ball_to_eye',
      title: 'Garden Games Gone Wrong',
      description: 'Playing catch in the villa garden, someone takes a ball straight to the eye.',
      allowedPhases: [DayPhase.MORNING], // Only at villa in the morning
      choices: [
        {
          text: 'Ice it and hope for the best',
          effects: { groupMorale: -5 }
        },
        {
          text: 'Take them to the local clinic',
          effects: { money: -100, energy: -15, groupMorale: 5, timeOfDay: 2 }
        },
        {
          text: 'Give them sunglasses and send them to the bar',
          effects: { money: -50, hangoverLevel: 10, groupMorale: 10, partyCount: 1 }
        }
      ]
    },
    {
      id: 'epic_swell',
      title: 'Dawn Patrol Alert!',
      description: 'You check the forecast and see epic conditions RIGHT NOW! Wake everyone up for dawn patrol?',
      allowedPhases: [DayPhase.MORNING], // Only at villa in morning
      choices: [
        {
          text: 'Get everyone up for dawn patrol!',
          effects: { surfsSoFar: 2, energy: -30, groupMorale: 25, timeOfDay: 4 }
        },
        {
          text: 'Let them sleep - surf later',
          effects: { groupMorale: 5 }
        }
      ]
    },
    {
      id: 'hangover_rebellion',
      title: 'Hangover Rebellion',
      description: 'Half the group is too hungover to surf. They\'re refusing to leave the villa.',
      allowedPhases: [DayPhase.MORNING], // Only at villa in the morning
      choices: [
        {
          text: 'Drag them to the beach anyway',
          effects: { groupMorale: -20, surfsSoFar: 1, energy: -10 }
        },
        {
          text: 'Let them rest - surf with who\'s able',
          effects: { surfsSoFar: 1, energy: -10, groupMorale: 5 }
        },
        {
          text: 'Hair of the dog - breakfast beers',
          effects: { money: -40, hangoverLevel: 10, groupMorale: 15, partyCount: 1 }
        }
      ]
    },
    {
      id: 'breakfast_event',
      title: 'Breakfast is Served!',
      description: 'Someone\'s made breakfast for the group! Who\'s cooking today?',
      allowedPhases: [DayPhase.MORNING], // Only at villa in the morning
      choices: [
        {
          text: 'Albin\'s breakfast burritos',
          effects: { energy: 15, groupMorale: 10 }
        },
        {
          text: 'Joey\'s special scramble',
          effects: { energy: 15, groupMorale: 10 }
        },
        {
          text: 'Jack\'s tomatoes with eggs (very continental)',
          effects: { energy: 15, groupMorale: 10 }
        }
      ]
    },
    {
      id: 'withers_pulled',
      title: 'Withers Has Pulled!',
      description: 'Withers has only gone and pulled a German bird! The lads are cheering him on but she\'s got a whole crew of mates.',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Buy drinks for her whole crew',
          effects: { money: -80, groupMorale: 25, hangoverLevel: 15, timeOfDay: 2 }
        },
        {
          text: 'Let Withers handle it himself',
          effects: { groupMorale: 10, timeOfDay: 1 }
        },
        {
          text: 'Drag him away - we\'re here to surf',
          effects: { groupMorale: -10 }
        }
      ]
    },
    {
      id: 'jagerbombs',
      title: 'JAGERBOMBS!',
      description: 'Someone\'s just ordered a round of Jagerbombs for the entire bar. The lads are absolutely buzzing!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Get stuck in - when in Portugal!',
          effects: { money: -60, hangoverLevel: 25, groupMorale: 30, energy: -20, timeOfDay: 1, partyCount: 1 }
        },
        {
          text: 'Just have one and pace yourself',
          effects: { money: -20, hangoverLevel: 10, groupMorale: 15, timeOfDay: 1 }
        },
        {
          text: 'Politely decline - you\'re driving',
          effects: { groupMorale: -5 }
        }
      ]
    },
    {
      id: 'joey_dancing',
      title: 'Joey\'s Throwing Shapes!',
      description: 'Joey\'s had a few too many and is absolutely throwing shapes on the dancefloor. He\'s either about to become a legend or get kicked out.',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Join him - let\'s make it a night!',
          effects: { hangoverLevel: 20, groupMorale: 25, energy: -25, timeOfDay: 2 }
        },
        {
          text: 'Film it for the group chat',
          effects: { groupMorale: 20, timeOfDay: 1 }
        },
        {
          text: 'Get him out before he\'s barred',
          effects: { groupMorale: -5, timeOfDay: 1 }
        }
      ]
    },
    {
      id: 'locals_challenge',
      title: 'Locals\' Drinking Challenge',
      description: 'A group of Portuguese locals are challenging the lads to a drinking contest. National pride is at stake!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Accept the challenge - for England!',
          effects: { money: -70, hangoverLevel: 30, groupMorale: 20, energy: -30, timeOfDay: 2, partyCount: 1 }
        },
        {
          text: 'Negotiate a lighter challenge',
          effects: { money: -40, hangoverLevel: 15, groupMorale: 10, timeOfDay: 1 }
        },
        {
          text: 'Respectfully decline',
          effects: { groupMorale: -10 }
        }
      ]
    },
    {
      id: 'karaoke_disaster',
      title: 'Karaoke Catastrophe',
      description: 'The bar has karaoke and someone\'s signed the whole group up for "Wonderwall". This could go very wrong.',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Embrace it - liquid courage first',
          effects: { money: -50, hangoverLevel: 15, groupMorale: 30, timeOfDay: 2 }
        },
        {
          text: 'Do it sober and own it',
          effects: { groupMorale: 15, energy: -10, timeOfDay: 1 }
        },
        {
          text: 'Fake a phone call and escape',
          effects: { groupMorale: -15 }
        }
      ]
    },
    {
      id: 'wocks_fights_germans',
      title: 'Wocks Kicks Off!',
      description: 'Wocks has gotten into a heated argument with some German lads at the bar. It\'s escalating fast and fists are about to fly!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Try to separate them before it gets worse',
          effects: { groupMorale: -15, money: -40, timeOfDay: 1 }
        },
        {
          text: 'Let them sort it out - lads will be lads',
          effects: { money: -120, groupMorale: -25, hangoverLevel: 20, energy: -20, timeOfDay: 2 }
        },
        {
          text: 'Buy everyone drinks to calm it down',
          effects: { money: -100, groupMorale: -5, hangoverLevel: 15, timeOfDay: 1 }
        }
      ]
    },
    {
      id: 'pickpocketed',
      title: 'Someone\'s Been Robbed!',
      description: 'One of the lads just realized their wallet is missing. Must have been pickpocketed in the crowded bar!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Cover them for the rest of the trip',
          effects: { money: -150, groupMorale: 10 }
        },
        {
          text: 'Lend them emergency cash only',
          effects: { money: -60, groupMorale: -5 }
        },
        {
          text: 'They need to call home for money',
          effects: { groupMorale: -20, energy: -10, timeOfDay: 2 }
        }
      ]
    },
    {
      id: 'massive_bar_tab',
      title: 'The Bar Tab Shock!',
      description: 'The bar tab arrives and it\'s MUCH higher than expected. Someone was ordering premium spirits all night!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Just pay it - what\'s done is done',
          effects: { money: -140, groupMorale: -10, hangoverLevel: 10 }
        },
        {
          text: 'Argue with the bartender',
          effects: { money: -110, groupMorale: -20, timeOfDay: 1 }
        },
        {
          text: 'Make everyone chip in extra',
          effects: { money: -80, groupMorale: -25 }
        }
      ]
    },
    {
      id: 'dave_breaks_glass',
      title: 'Dave\'s Smashed It!',
      description: 'Dave\'s knocked over an entire tray of glasses while gesticulating wildly. The bar owner is NOT happy.',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Pay for damages immediately',
          effects: { money: -90, groupMorale: -10 }
        },
        {
          text: 'Try to negotiate the damages down',
          effects: { money: -60, groupMorale: -15, timeOfDay: 1 }
        },
        {
          text: 'Make a runner for it',
          effects: { money: 0, groupMorale: -30, energy: -15 }
        }
      ]
    },
    {
      id: 'ejected_from_bar',
      title: 'KICKED OUT!',
      description: 'The bouncer has had enough of the lads\' antics. You\'re all being ejected from the bar!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Apologize profusely and beg to stay',
          effects: { groupMorale: -20, money: -50 }
        },
        {
          text: 'Leave with dignity intact',
          effects: { groupMorale: -15, energy: -10 }
        },
        {
          text: 'Find another bar immediately',
          effects: { money: -80, groupMorale: -5, hangoverLevel: 15, timeOfDay: 2 }
        }
      ]
    },
    {
      id: 'lost_phone',
      title: 'Lost Phone Disaster!',
      description: 'Conroy can\'t find his phone anywhere. He had all the accommodation details and tomorrow\'s surf forecast on it!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Spend ages looking for it',
          effects: { groupMorale: -15, energy: -20, timeOfDay: 2 }
        },
        {
          text: 'Buy a cheap replacement tomorrow',
          effects: { money: -100, groupMorale: -10 }
        },
        {
          text: 'Just deal without it',
          effects: { groupMorale: -20, energy: -10 }
        }
      ]
    },
    {
      id: 'drinks_spilled',
      title: 'Round of Drinks DESTROYED!',
      description: 'You\'ve just bought a massive round and someone\'s bumped into you. Drinks everywhere!',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Buy another round - chin up',
          effects: { money: -70, groupMorale: 5, hangoverLevel: 10 }
        },
        {
          text: 'Salvage what you can',
          effects: { groupMorale: -15 }
        },
        {
          text: 'Demand the other person pays',
          effects: { groupMorale: -20, timeOfDay: 1 }
        }
      ]
    },
    {
      id: 'gin_and_tonics',
      title: 'Cutting\'s Gin & Tonic Crusade!',
      description: 'Cutting is absolutely adamant that everyone should switch from beer to gin & tonics. "Much more civilized, lads! Better for the head tomorrow too!"',
      allowedPhases: [DayPhase.BAR], // Only at bar
      choices: [
        {
          text: 'Switch to G&Ts - Cutting knows best',
          effects: { money: -60, hangoverLevel: -10, groupMorale: 15, timeOfDay: 1 }
        },
        {
          text: 'Compromise - one G&T then back to beer',
          effects: { money: -40, hangoverLevel: -5, groupMorale: 8, timeOfDay: 1 }
        },
        {
          text: 'Stick to beer - none of that posh stuff',
          effects: { groupMorale: -8 }
        }
      ]
    }
  ];

  getRandomEvent(): GameEvent {
    const randomIndex = Math.floor(Math.random() * this.events.length);
    return this.events[randomIndex];
  }

  // Get a random event that can occur in the current phase and hasn't occurred today
  getRandomEventForPhase(currentPhase: DayPhase, eventsTriggeredToday: string[]): GameEvent | null {
    // Filter events that:
    // 1. Can occur in the current phase
    // 2. Haven't been triggered today
    const availableEvents = this.events.filter(event =>
      event.allowedPhases.includes(currentPhase) &&
      !eventsTriggeredToday.includes(event.id)
    );

    if (availableEvents.length === 0) {
      return null; // No events available
    }

    const randomIndex = Math.floor(Math.random() * availableEvents.length);
    return availableEvents[randomIndex];
  }

  getEventById(id: string): GameEvent | undefined {
    return this.events.find(event => event.id === id);
  }
}
